import(/* webpackMode: "eager" */ "/var/www/nextjs/src/app/[locale]/@cart/default.tsx");
